const MAIN_SITE = import.meta.env.VITE_MAIN_SITE_URL || 'https://nera.systems';

export default function Footer() {
  return (
    <footer className="bg-white p-0">
      <div className="w-full max-w-[1200px] mx-auto px-6">
        <div
          className="relative overflow-hidden"
          style={{
            borderRadius: '34px 34px 0 0',
            border: '2px solid #FFF',
            background: 'linear-gradient(270deg, #D8EBFE 0%, #ECF6FF 100%)',
            boxShadow: '0 4px 29.8px 0 rgba(0, 74, 169, 0.06)',
            padding: '5rem 3rem 2rem',
          }}
        >
          {/* Network trace decorations */}
          <svg className="absolute left-0 top-5 pointer-events-none opacity-20" width="320" height="200" viewBox="0 0 320 200" fill="none">
            <line x1="0" y1="30" x2="30" y2="30" stroke="#B8D4F0" strokeWidth="2"/>
            <line x1="30" y1="30" x2="50" y2="50" stroke="#B8D4F0" strokeWidth="2"/>
            <line x1="50" y1="50" x2="50" y2="80" stroke="#B8D4F0" strokeWidth="2"/>
            <line x1="50" y1="80" x2="80" y2="80" stroke="#B8D4F0" strokeWidth="2"/>
            <line x1="80" y1="80" x2="100" y2="60" stroke="#B8D4F0" strokeWidth="2"/>
            <line x1="100" y1="60" x2="140" y2="60" stroke="#B8D4F0" strokeWidth="2"/>
            <line x1="140" y1="60" x2="160" y2="40" stroke="#0C91C6" strokeWidth="2"/>
            <line x1="160" y1="40" x2="200" y2="40" stroke="#0C91C6" strokeWidth="2"/>
            <line x1="200" y1="40" x2="220" y2="20" stroke="#0C91C6" strokeWidth="2"/>
            <line x1="50" y1="80" x2="30" y2="100" stroke="#B8D4F0" strokeWidth="2"/>
            <line x1="30" y1="100" x2="30" y2="130" stroke="#B8D4F0" strokeWidth="2"/>
            <line x1="30" y1="130" x2="50" y2="150" stroke="#B8D4F0" strokeWidth="2"/>
            <line x1="50" y1="150" x2="80" y2="150" stroke="#B8D4F0" strokeWidth="2"/>
            <circle cx="0" cy="30" r="6" fill="#D8EBFE" stroke="#B8D4F0" strokeWidth="1.5"/>
            <circle cx="30" cy="30" r="5" fill="#D8EBFE" stroke="#B8D4F0" strokeWidth="1.5"/>
            <circle cx="50" cy="50" r="6" fill="#D8EBFE" stroke="#B8D4F0" strokeWidth="1.5"/>
            <circle cx="50" cy="80" r="8" fill="#D8EBFE" stroke="#B8D4F0" strokeWidth="1.5"/>
            <circle cx="80" cy="80" r="7" fill="#D8EBFE" stroke="#B8D4F0" strokeWidth="1.5"/>
            <circle cx="100" cy="60" r="5" fill="#D8EBFE" stroke="#B8D4F0" strokeWidth="1.5"/>
            <circle cx="140" cy="60" r="7" fill="#D8EBFE" stroke="#B8D4F0" strokeWidth="1.5"/>
            <circle cx="160" cy="40" r="6" fill="#0C91C6" stroke="#0C91C6" strokeWidth="1"/>
            <circle cx="200" cy="40" r="5" fill="#0C91C6" stroke="#0C91C6" strokeWidth="1"/>
            <circle cx="220" cy="20" r="7" fill="#0C91C6" stroke="#0C91C6" strokeWidth="1"/>
            <circle cx="30" cy="100" r="5" fill="#D8EBFE" stroke="#B8D4F0" strokeWidth="1.5"/>
            <circle cx="30" cy="130" r="6" fill="#D8EBFE" stroke="#B8D4F0" strokeWidth="1.5"/>
            <circle cx="50" cy="150" r="5" fill="#D8EBFE" stroke="#B8D4F0" strokeWidth="1.5"/>
            <circle cx="80" cy="150" r="6" fill="#D8EBFE" stroke="#B8D4F0" strokeWidth="1.5"/>
          </svg>

          <svg className="absolute right-0 top-5 pointer-events-none opacity-20" width="320" height="200" viewBox="0 0 320 200" fill="none">
            <line x1="320" y1="30" x2="290" y2="30" stroke="#B8D4F0" strokeWidth="2"/>
            <line x1="290" y1="30" x2="270" y2="50" stroke="#B8D4F0" strokeWidth="2"/>
            <line x1="270" y1="50" x2="270" y2="80" stroke="#B8D4F0" strokeWidth="2"/>
            <line x1="270" y1="80" x2="240" y2="80" stroke="#B8D4F0" strokeWidth="2"/>
            <line x1="240" y1="80" x2="220" y2="60" stroke="#B8D4F0" strokeWidth="2"/>
            <line x1="220" y1="60" x2="180" y2="60" stroke="#B8D4F0" strokeWidth="2"/>
            <line x1="180" y1="60" x2="160" y2="40" stroke="#0C91C6" strokeWidth="2"/>
            <line x1="160" y1="40" x2="120" y2="40" stroke="#0C91C6" strokeWidth="2"/>
            <line x1="120" y1="40" x2="100" y2="20" stroke="#0C91C6" strokeWidth="2"/>
            <line x1="270" y1="80" x2="290" y2="100" stroke="#B8D4F0" strokeWidth="2"/>
            <line x1="290" y1="100" x2="290" y2="130" stroke="#B8D4F0" strokeWidth="2"/>
            <line x1="290" y1="130" x2="270" y2="150" stroke="#B8D4F0" strokeWidth="2"/>
            <line x1="270" y1="150" x2="240" y2="150" stroke="#B8D4F0" strokeWidth="2"/>
            <circle cx="320" cy="30" r="6" fill="#D8EBFE" stroke="#B8D4F0" strokeWidth="1.5"/>
            <circle cx="290" cy="30" r="5" fill="#D8EBFE" stroke="#B8D4F0" strokeWidth="1.5"/>
            <circle cx="270" cy="50" r="6" fill="#D8EBFE" stroke="#B8D4F0" strokeWidth="1.5"/>
            <circle cx="270" cy="80" r="8" fill="#D8EBFE" stroke="#B8D4F0" strokeWidth="1.5"/>
            <circle cx="240" cy="80" r="7" fill="#D8EBFE" stroke="#B8D4F0" strokeWidth="1.5"/>
            <circle cx="220" cy="60" r="5" fill="#D8EBFE" stroke="#B8D4F0" strokeWidth="1.5"/>
            <circle cx="180" cy="60" r="7" fill="#D8EBFE" stroke="#B8D4F0" strokeWidth="1.5"/>
            <circle cx="160" cy="40" r="6" fill="#0C91C6" stroke="#0C91C6" strokeWidth="1"/>
            <circle cx="120" cy="40" r="5" fill="#0C91C6" stroke="#0C91C6" strokeWidth="1"/>
            <circle cx="100" cy="20" r="7" fill="#0C91C6" stroke="#0C91C6" strokeWidth="1"/>
            <circle cx="290" cy="100" r="5" fill="#D8EBFE" stroke="#B8D4F0" strokeWidth="1.5"/>
            <circle cx="290" cy="130" r="6" fill="#D8EBFE" stroke="#B8D4F0" strokeWidth="1.5"/>
            <circle cx="270" cy="150" r="5" fill="#D8EBFE" stroke="#B8D4F0" strokeWidth="1.5"/>
            <circle cx="240" cy="150" r="6" fill="#D8EBFE" stroke="#B8D4F0" strokeWidth="1.5"/>
          </svg>

          {/* Content */}
          <div className="relative z-[1]">
            {/* Grid */}
            <div className="grid grid-cols-1 md:grid-cols-[1.5fr_1fr_1.5fr] gap-10 md:gap-20 mb-10">
              {/* Brand */}
              <div>
                <a href={MAIN_SITE} className="flex items-center gap-2 mb-6">
                  <img src="/images/logo-icon.svg" alt="Nera Icon" className="w-20 h-20" />
                  <img src="/images/logo-text.svg" alt="Nera" className="h-8 w-auto" />
                </a>
                <div className="flex gap-4 mt-8">
                  {/* X / Twitter */}
                  <a href="#" aria-label="X" className="text-[#0B3D91] hover:text-[#00A3E0] transition-colors">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                    </svg>
                  </a>
                  {/* LinkedIn */}
                  <a href="#" aria-label="LinkedIn" className="text-[#0B3D91] hover:text-[#00A3E0] transition-colors">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                      <path d="M19 3a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h14m-.5 15.5v-5.3a3.26 3.26 0 0 0-3.26-3.26c-.85 0-1.84.52-2.32 1.3v-1.11h-2.79v8.37h2.79v-4.93c0-.77.62-1.4 1.39-1.4a1.4 1.4 0 0 1 1.4 1.4v4.93h2.79M6.88 8.56a1.68 1.68 0 0 0 1.68-1.68c0-.93-.75-1.69-1.68-1.69a1.69 1.69 0 0 0-1.69 1.69c0 .93.76 1.68 1.69 1.68m1.39 9.94v-8.37H5.5v8.37h2.77Z"/>
                    </svg>
                  </a>
                </div>
              </div>

              {/* Links */}
              <div className="flex flex-col gap-4">
                <a href={`${MAIN_SITE}/solutions/`} className="text-base font-semibold text-[#0B3D91] hover:text-[#00A3E0] transition-colors">Solutions</a>
                <a href={`${MAIN_SITE}/pricing`} className="text-base font-semibold text-[#0B3D91] hover:text-[#00A3E0] transition-colors">Pricing</a>
                <a href={`${MAIN_SITE}/trust`} className="text-base font-semibold text-[#0B3D91] hover:text-[#00A3E0] transition-colors">Trust Center</a>
                <a href={`${MAIN_SITE}/about`} className="text-base font-semibold text-[#0B3D91] hover:text-[#00A3E0] transition-colors">About Us</a>
                <a href={`${MAIN_SITE}/blogs/`} className="text-base font-semibold text-[#0B3D91] hover:text-[#00A3E0] transition-colors">Blogs</a>
                <a href={`${MAIN_SITE}/press/`} className="text-base font-semibold text-[#0B3D91] hover:text-[#00A3E0] transition-colors">Press</a>
                <a href={`${MAIN_SITE}/releases/`} className="text-base font-semibold text-[#0B3D91] hover:text-[#00A3E0] transition-colors">Release</a>
                <a href={`${MAIN_SITE}/contact`} className="text-base font-semibold text-[#0B3D91] hover:text-[#00A3E0] transition-colors">Contact</a>
              </div>

              {/* Info */}
              <div>
                <h4 className="text-base font-bold text-[#0B3D91] mb-2">Address:</h4>
                <p className="text-sm text-[#333] leading-relaxed">755 Page Mill Road, Palo Alto, CA 94304</p>
                <p className="text-sm text-[#333] leading-relaxed">Monday – Friday 8:00 a.m. – 5:00 p.m.</p>
                <h4 className="text-base font-bold text-[#0B3D91] mb-2 mt-6">Contact:</h4>
                <p className="text-sm text-[#333] leading-relaxed">
                  <a href="mailto:info@nera.systems" className="hover:text-[#00A3E0] transition-colors">info@nera.systems</a>
                </p>
              </div>
            </div>

            {/* Bottom */}
            <div className="flex flex-col sm:flex-row justify-between items-center pt-8 border-t border-[rgba(0,74,169,0.1)] gap-4">
              <p className="text-sm text-[#666]">© {new Date().getFullYear()} NERA SYSTEMS. All rights reserved.</p>
              {/* Same six legal links as the site footer. These were three
                  href="#" placeholders, one of them Cookie Policy, which is
                  not a page that exists. */}
              <div className="flex flex-wrap gap-x-6 gap-y-2 justify-center sm:justify-end">
                <a href={`${MAIN_SITE}/trust`} className="text-sm text-[#333] underline hover:text-[#00A3E0] transition-colors whitespace-nowrap">Trust Center</a>
                <a href={`${MAIN_SITE}/security`} className="text-sm text-[#333] underline hover:text-[#00A3E0] transition-colors whitespace-nowrap">Security FAQs</a>
                <a href={`${MAIN_SITE}/secureanalytics-privacy`} className="text-sm text-[#333] underline hover:text-[#00A3E0] transition-colors whitespace-nowrap">Privacy Policy</a>
                <a href={`${MAIN_SITE}/terms`} className="text-sm text-[#333] underline hover:text-[#00A3E0] transition-colors whitespace-nowrap">Terms of Service</a>
                <a href={`${MAIN_SITE}/website-terms-of-use`} className="text-sm text-[#333] underline hover:text-[#00A3E0] transition-colors whitespace-nowrap">Website Terms of Use</a>
                <a href={`${MAIN_SITE}/dpa`} className="text-sm text-[#333] underline hover:text-[#00A3E0] transition-colors whitespace-nowrap">DPA</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
